import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './PernamentMedicationItem.module.scss';
import PermanentMedicationEditModal from './PernamentMedicationEdit/PermanentMedicationEditModal';
import { useDeleteUserMedicationLastedMutation } from '../../../../graphql/graphql';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';
import RemoveButton from '../../../../Components/Button/RemoveButton';
import PermanentMedicationHVLPItem, {
	PermanentMedicamentHVLP,
} from './PernamentMedicationHVLPItem';
import PermanentMedicationIPLPItem, {
	PermanentMedicamentIPLP,
} from './PernamentMedicationIPLPItem';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';

export interface IPermanentMedicament {
	id: string;
	data: PermanentMedicamentHVLP | PermanentMedicamentIPLP;
}

interface Props {
	item: IPermanentMedicament;
	onEdit: () => void;
	onDelete: () => void;
	onSelectMedicament: (medicament: IPermanentMedicament) => void;
	isSelected: boolean;
	onIssueAgain: (medicament: IPermanentMedicament) => void;
}

const PermanentMedicationItem: React.FC<Props> = ({
	item,
	onDelete,
	onEdit,
	isSelected,
	onSelectMedicament,
	onIssueAgain,
}) => {
	const [isEditOpen, setIsEditOpen] = useState(false);
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();

	const { formType } = item.data;

	const isHVLP = formType === 'hvlp';
	const isIPLP = formType === 'iplp';

	const [deleteUserMedicationLasted] = useDeleteUserMedicationLastedMutation();

	const handleCheckItem = () => {
		onSelectMedicament(item);
	};

	const handleRemove = async () => {
		const result = await deleteUserMedicationLasted({ id: item.id });
		if ('data' in result && result.data.deleteUserMedicationLasted?.status) {
			showNotificationSuccess({
				content: t('component.permanentMedicationItem.successfullyRemoved'),
			});
			onDelete();
		}
	};

	const handleOnEdit = () => {
		setIsEditOpen(false);
		onEdit();
	};

	return (
		<>
			<div className={styles.item}>
				<div className={styles.checkWrapper}>
					<Checkbox value={isSelected} onChange={handleCheckItem} />
				</div>
				{isHVLP && (
					<PermanentMedicationHVLPItem
						item={item.data as PermanentMedicamentHVLP}
					/>
				)}
				{isIPLP && (
					<PermanentMedicationIPLPItem
						item={item.data as PermanentMedicamentIPLP}
					/>
				)}
				<div className={styles.controls}>
					<LinkButton
						onClick={() => setIsEditOpen(true)}
						title='component.permanentMedicationItem.edit'
						theme={Theme.BLUE}
					/>
					<LinkButton
						onClick={() => onIssueAgain(item)}
						title='component.permanentMedicationItem.issueAgain'
						theme={Theme.BLUE}
					/>
					<RemoveButton
						onClick={handleRemove}
						title='component.permanentMedicationItem.remove'
						disableFlashMessage
					/>
				</div>
			</div>
			{isEditOpen && (
				<PermanentMedicationEditModal
					isOpen
					onClose={() => setIsEditOpen(false)}
					medicament={item}
					formType={formType}
					onEdit={handleOnEdit}
				/>
			)}
		</>
	);
};

export default PermanentMedicationItem;
